export enum MonitoringBulkActionTypeEnum {
    'export',
    'addTags',
    'removeTags',
    'addFolder',
    'removeFolder',
    'setSentiment',
    'addTagsFromTaggingTopics',
    'renormalize',
    'removeSentiment',
    'copyMentionsToAccount',
    'deleteFromAccount'
}
